import styled from 'styled-components';

import { colors } from '../../../../utils/utils';

const ExpandWrapper = styled.div`
    font-size: 12px;
    font-weight: 600;
    color: ${colors.gray.dark};

    margin-top: 8px;
    margin-left: 4px;

    display: inline-flex;
    flex-direction: row;

    &:hover {
        cursor: pointer;
    }
`;

export default ExpandWrapper;
